import Api from 'common/middleware/api';

export const CHAPTER_REPORT_ERROR = 'CHAPTER_REPORT_ERROR';
export function chapterReportError(error) {
  return {
    error,
    type: CHAPTER_REPORT_ERROR,
  };
}

export const CHAPTER_REPORT_REQUEST = 'CHAPTER_REPORT_REQUEST';
export function chapterReportRequest(chapterId) {
  return {
    chapterId,
    type: CHAPTER_REPORT_REQUEST,
  };
}

export const CHAPTER_REPORT_SUCCESS = 'CHAPTER_REPORT_SUCCESS';
export function chapterReportSuccess(report) {
  return {
    report,
    type: CHAPTER_REPORT_SUCCESS,
  };
}

export const FETCH_CHAPTER_REPORT = 'FETCH_CHAPTER_REPORT';

function retry(fn, retries, delay) {
  return fn().catch((err) => {
    if (retries > 0) {
      return new Promise((resolve) => setTimeout(resolve, delay)).then(() =>
        retry(fn, retries - 1, delay),
      );
    } else {
      throw err;
    }
  });
}
export function fetchChapterReport(chapterId) {
  return (dispatch) => {
    dispatch(chapterReportRequest(chapterId));
    function doFetch() {
      return Api.fetchChapterReport(chapterId)
        .then(Api.checkStatus)
        .then((response) => response.json())
        .then((json) => dispatch(chapterReportSuccess(json)));
    }
    // retry for 10 minutes every 10sec
    return retry(doFetch, 6 * 10, 10_000).catch((error) => {
      dispatch(chapterReportError(error));
    });
  };
}
